import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { handleAuthentication, showSnackBar } from "@containers/App/reducer"
import { parsePageInfoWidget, parseWidgetData, parseSkuList } from "./parser"

const initialState = {
    isLoading: false,
    isFetched: false,
    error: null,
    widgets: {},
    pageInfoWidgets: {},
    selectedOptionId: null,
    etaSelectionData: {},
    listOfItems: {},
    productShipmentData: [],
    analyticsData: {},
}

export const cartSummaryPageSlice = createSlice({
    name: "cartSummaryPage",
    initialState: initialState,
    reducers: {
        reset: () => initialState,
        setListOfItems: (state, action) => {
            state.listOfItems = parseSkuList(action.payload)
        },
    },
    extraReducers: (builder) => {
        //handle asynchronous actions
        builder.addCase(fetchSummaryData.fulfilled, (state, action) => {
            state.isLoading = false
            state.isFetched = true
            state.error = false
            let data = parseWidgetData(action.payload?.widgets)
            state.widgets = data.widgetData
            state.productShipmentData = data.productShipmentData
            state.pageInfoWidgets = parsePageInfoWidget(action.payload)
            state.analyticsData = action.payload.analytics_data
            state.mixPanelData = action.payload.analytics_data_mixpanel
        }),
            builder.addCase(fetchSummaryData.pending, (state) => {
                state.isLoading = true
                state.isFetched = false
                state.error = false
            }),
            builder.addCase(fetchSummaryData.rejected, (state) => {
                state.isLoading = false
                state.error = true
                state.isFetched = false
            })
    },
})

export const fetchSummaryData = createAsyncThunk(
    "cartSummaryPage/fetchSummaryPageData",
    async (_arg, { extra, rejectWithValue, dispatch, getState }) => {
        const { api } = extra
        const cartType = getState().shellReducer.cartType
        const errorCallback = _arg?.errorCallback
        try {
            const res = await api.get(`/api/v4/carts/summary?types=${cartType}`)
            return Promise.resolve(res.data)
        } catch (err) {
            if (err.error?.errors) {
                if (typeof errorCallback === "function") errorCallback?.(err)
            }
            const onServer = typeof window === "undefined"
            if (!onServer && (err.status_code === 403 || err.status_code === 401))
                dispatch(handleAuthentication())
            return rejectWithValue(err)
        }
    }
)

export const availUnavailNeucoins = createAsyncThunk(
    "cartSummaryPage/availUnavailNeucoins",
    async (arg, { extra, rejectWithValue, dispatch }) => {
        const { api } = extra
        const { tcpPointsAvailed, tcpPointsRedeemed, successCallback } = arg
        try {
            const res = await api.get(
                `/api/v5/carts/details?types=pharmacy&response_type=full&cashback_availed=false&tcp_points_availed=${tcpPointsAvailed}&tcp_points_redeemed=${tcpPointsRedeemed}`
            )
            successCallback?.(res.data)
            return Promise.resolve(res?.data)
        } catch (err) {
            if (err?.status_code !== 403 || err?.status_code !== 401) {
                showSnackBar(dispatch, err.error.message)
            }
            const onServer = typeof window === "undefined"
            if (!onServer && (err.status_code === 403 || err.status_code === 401))
                dispatch(handleAuthentication())
            return rejectWithValue(err.error)
        }
    }
)
export const availUnavailNeucoinsLabs = createAsyncThunk(
    "cartSummaryPage/availUnavailNeucoinsLabs",
    async (_arg, { extra, rejectWithValue, dispatch, getState }) => {
        const { cartType } = getState().shellReducer
        const { api } = extra
        const { successCallback, queryParamKey, queryParamValue } = _arg
        try {
            const payload = {
                [queryParamKey]: queryParamValue,
            }
            const res = await api.put(`api/v4/carts/preferences?types=${cartType}`, payload)
            successCallback?.()
            return Promise.resolve(res?.data)
        } catch (err) {
            if (err?.status_code !== 403 || err?.status_code !== 401) {
                showSnackBar(dispatch, err.error.message)
            }
            const onServer = typeof window === "undefined"
            if (!onServer && (err.status_code === 403 || err.status_code === 401))
                dispatch(handleAuthentication())
            return rejectWithValue(err.error)
        }
    }
)

export const cartSummaryPageReducer = cartSummaryPageSlice.reducer
export const { reset, setListOfItems } = cartSummaryPageSlice.actions
